/* ==========================================================
   Mifaja 3D — comportamiento global del tema
   ========================================================== */
(function () {
  'use strict';

  var cfg = window.mifaja || {};
  var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- formato de dinero ----------
     Reproduce money_format de Shopify sin depender de jQuery.       */
  function dinero(centimos, formato) {
    formato = formato || cfg.moneda || '{{amount}}';
    var valor = '';
    var patron = /\{\{\s*(\w+)\s*\}\}/;

    function separar(numero, decimales, separadorMiles, separadorDecimal) {
      if (isNaN(numero) || numero === null) return 0;
      numero = (numero / 100.0).toFixed(decimales);
      var partes = numero.split('.');
      var entera = partes[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + separadorMiles);
      var decimal = partes[1] ? separadorDecimal + partes[1] : '';
      return entera + decimal;
    }

    switch ((formato.match(patron) || [])[1]) {
      case 'amount':                    valor = separar(centimos, 2, ',', '.'); break;
      case 'amount_no_decimals':        valor = separar(centimos, 0, ',', '.'); break;
      case 'amount_with_comma_separator': valor = separar(centimos, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': valor = separar(centimos, 0, '.', ','); break;
      case 'amount_with_space_separator': valor = separar(centimos, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': valor = separar(centimos, 0, ' ', ','); break;
      default:                          valor = separar(centimos, 2, '.', ','); break;
    }
    return formato.replace(patron, valor);
  }
  window.mifajaDinero = dinero;

  /* ---------- reveals ---------- */
  function reveals(raiz) {
    var els = $$('.rev, .mf-r', raiz);
    if (!els.length) return;
    if (!cfg.animaciones || quieto || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); e.classList.add('mf-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          e.target.classList.add('mf-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- contadores ---------- */
  function contadores(raiz) {
    var els = $$('.cifra[data-n]', raiz);
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.textContent = el.dataset.n; });
      return;
    }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var el = e.target;
        var fin = parseFloat(el.dataset.n);
        var dec = parseInt(el.dataset.dec || 0, 10);
        var suf = el.dataset.suf || '';
        var t0 = null, dur = (quieto || !cfg.animaciones) ? 0 : 1500;
        function paso(t) {
          if (t0 === null) t0 = t;
          var p = dur ? Math.min((t - t0) / dur, 1) : 1;
          var v = fin * (1 - Math.pow(1 - p, 3));
          el.textContent = (dec ? (v / 10).toFixed(1).replace('.', ',') : Math.round(v).toLocaleString('es-ES')) + suf;
          if (p < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
      });
    }, { threshold: 0.5 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- titular letra a letra ---------- */
  function titularAnimado(raiz) {
    var h = $('[data-letras]', raiz);
    if (!h || h.dataset.hecho) return;
    h.dataset.hecho = '1';
    var txt = h.textContent.trim();
    if (!cfg.animaciones || quieto || txt.length > 90) return;
    var frag = document.createDocumentFragment();
    for (var i = 0; i < txt.length; i++) {
      var s = document.createElement('span');
      s.className = 'letra';
      s.textContent = txt[i] === ' ' ? '\u00A0' : txt[i];
      s.style.transitionDelay = (0.3 + i * 0.024) + 's';
      frag.appendChild(s);
    }
    h.textContent = '';
    h.appendChild(frag);
    requestAnimationFrame(function () {
      $$('.letra', h).forEach(function (l) { l.classList.add('in'); });
    });
  }

  /* ---------- scroll: progreso, cabecera, barra fija ---------- */
  var tic = false;
  function onScroll() {
    var y = window.scrollY;
    var alto = document.documentElement.scrollHeight - window.innerHeight;
    var prog = $('#progreso');
    if (prog) prog.style.width = (alto > 0 ? (y / alto) * 100 : 0) + '%';

    var cab = $('.cabecera');
    if (cab) cab.classList.toggle('peg', y > 40);

    var compra = $('[data-caja-compra]');
    var fija = $('[data-barra-fija]');
    if (compra && fija) {
      var r = compra.getBoundingClientRect();
      fija.classList.toggle('ver', r.bottom < 90);
    }

    document.dispatchEvent(new CustomEvent('mifaja:scroll'));
    tic = false;
  }
  window.addEventListener('scroll', function () {
    if (!tic) { requestAnimationFrame(onScroll); tic = true; }
  }, { passive: true });
  window.addEventListener('resize', onScroll);

  /* ---------- carrito por AJAX ---------- */
  function anadirAlCarrito(items) {
    return fetch(cfg.rutas.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || cfg.textos.error);
        return data;
      });
    });
  }
  window.mifajaAnadir = anadirAlCarrito;

  /* ---------- menu movil ---------- */
  function menuMovil() {
    var btn = $('[data-menu-btn]');
    var nav = $('[data-nav]');
    if (!btn || !nav) return;
    btn.addEventListener('click', function () {
      var abierto = nav.hasAttribute('hidden');
      if (abierto) { nav.removeAttribute('hidden'); } else { nav.setAttribute('hidden', ''); }
      btn.setAttribute('aria-expanded', abierto ? 'true' : 'false');
    });
  }


  /* ---------- parallax suave en bloques marcados ---------- */
  function parallax() {
    if (quieto || !cfg.animaciones) return;
    var els = $$('[data-parallax]').filter(function (e) {
      return parseFloat(e.dataset.parallax) > 0;
    });
    if (!els.length) return;
    var tic2 = false;
    function mover() {
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        var amp = parseFloat(el.dataset.parallax);
        var p = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.transform = 'translate3d(0,' + (p * -amp) + 'px,0)';
      });
      tic2 = false;
    }
    window.addEventListener('scroll', function () {
      if (!tic2) { requestAnimationFrame(mover); tic2 = true; }
    }, { passive: true });
    mover();
  }

  /* ---------- transicion entre paginas ----------
     Cubre el cambio de pagina con una cortina en vez del parpadeo en blanco.
     Solo para enlaces internos normales: respeta ctrl/cmd-clic, target y
     descargas, y se desactiva con prefers-reduced-motion.                     */
  function transiciones() {
    if (quieto || !cfg.animaciones) return;
    var cortina = document.createElement('div');
    cortina.id = 'cortina';
    document.body.appendChild(cortina);
    requestAnimationFrame(function () { cortina.classList.add('abierta'); });

    document.addEventListener('click', function (e) {
      if (e.defaultPrevented) return;
      var a = e.target.closest('a');
      if (!a) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      if (a.target && a.target !== '_self') return;
      if (a.hasAttribute('download')) return;
      var href = a.getAttribute('href') || '';
      if (!href || href.charAt(0) === '#' || href.indexOf('mailto:') === 0 ||
          href.indexOf('tel:') === 0 || href.indexOf('javascript:') === 0) return;
      if (a.hostname && a.hostname !== window.location.hostname) return;
      e.preventDefault();
      cortina.classList.remove('abierta');
      cortina.classList.add('cerrando');
      setTimeout(function () { window.location.href = a.href; }, 380);
    });

    /* al volver con el boton atras, el navegador restaura la pagina: reabrir */
    window.addEventListener('pageshow', function (ev) {
      if (ev.persisted) { cortina.classList.remove('cerrando'); cortina.classList.add('abierta'); }
    });
  }


  /* ---------- inclinacion 3D con el raton ----------
     Rota el elemento sobre sus ejes X e Y segun la posicion del cursor.
     Es transform 3D real con perspectiva en el contenedor, no una sombra
     que finge volumen. Se desactiva en tactil y con reduced-motion.       */
  function tilt3d(raiz) {
    if (quieto || !cfg.animaciones) return;
    if (window.matchMedia('(hover: none)').matches) return;

    var objetivos = $$('.demo-par, .op', raiz);
    objetivos.forEach(function (el) {
      if (el.dataset.tilt) return;
      el.dataset.tilt = '1';

      var raf = null;
      var maxX = parseFloat(el.dataset.tiltX || 7);
      var maxY = parseFloat(el.dataset.tiltY || 9);

      function mover(e) {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          var r = el.getBoundingClientRect();
          if (!r.width || !r.height) return;
          var px = (e.clientX - r.left) / r.width - 0.5;
          var py = (e.clientY - r.top) / r.height - 0.5;
          el.style.transform =
            'perspective(1000px) rotateX(' + (-py * maxX) + 'deg) rotateY(' +
            (px * maxY) + 'deg) translateZ(10px)';
        });
      }
      function entrar() { el.classList.add('activo'); }
      function salir() {
        el.classList.remove('activo');
        if (raf) { cancelAnimationFrame(raf); raf = null; }
        el.style.transform = '';
      }

      el.addEventListener('mouseenter', entrar);
      el.addEventListener('mousemove', mover);
      el.addEventListener('mouseleave', salir);
    });
  }

  /* ---------- giro 3D del banner ligado al scroll ---------- */
  function banner3d() {
    if (quieto || !cfg.animaciones) return;
    var imgs = $$('.banner-img');
    if (!imgs.length) return;
    var tic3 = false;
    function mover() {
      var vh = window.innerHeight;
      imgs.forEach(function (img) {
        var r = img.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var p = (r.top + r.height / 2 - vh / 2) / vh;
        img.style.transform =
          'perspective(1400px) rotateX(' + (p * 2.4) + 'deg) translate3d(0,' +
          (p * -34) + 'px,0) scale(1.16)';
      });
      tic3 = false;
    }
    window.addEventListener('scroll', function () {
      if (!tic3) { requestAnimationFrame(mover); tic3 = true; }
    }, { passive: true });
    mover();
  }

  /* ---------- corazones de favoritos ---------- */
  function favoritos(raiz) {
    $$('[data-love]', raiz).forEach(function (b) {
      if (b.dataset.listo) return;
      b.dataset.listo = '1';
      b.addEventListener('click', function (e) {
        e.preventDefault();
        b.classList.toggle('mf-on');
        b.setAttribute('aria-pressed', b.classList.contains('mf-on') ? 'true' : 'false');
      });
    });
  }

  /* ---------- arranque ---------- */
  function arrancar(raiz) {
    reveals(raiz);
    contadores(raiz);
    titularAnimado(raiz);
    parallax();
    tilt3d(raiz);
    banner3d();
    favoritos(raiz);
  }

  document.addEventListener('DOMContentLoaded', function () {
    arrancar(document);
    menuMovil();
    transiciones();
    onScroll();
  });

  /* recarga de secciones en el editor de temas */
  document.addEventListener('shopify:section:load', function (e) {
    arrancar(e.target);
    menuMovil();
    onScroll();
  });
})();
